import {EEntityType} from 'shared/constants/entities';
import {TDispatch} from 'store/config/types';

import {fetchDashboardData} from '../api/dashboard-api';
import {setData} from '../data-actions';
import {IEntityData} from '../data-types';

export const loadDashboardData = (
    entityName: string,
    fieldKey: string,
    referenceUrl: string,
    context?: IEntityData,
    useContext?: boolean,
) => async (dispatch: TDispatch) => {
    try {
        const {data} = await fetchDashboardData(referenceUrl, useContext ? context : undefined);
        dispatch(setData({
            entityName,
            entityType: EEntityType.DASHBOARD,
            data: {
                [fieldKey]: {
                    dataTable: data?.dataTable.map(v => ({
                        key: v.entityName,
                        label: v.entityDescription,
                        value: v.count,
                    })) || [],

                    recordsTotal: data?.recordsTotal,
                },
            },
        }));
    } catch (e) {
        console.error(e);
    }
};
